import { ZENDESK_SUPPORT } from '@spotahome/customer-graphql-modules/dist/constants';

import {
  CITY,
  MOVE_IN_DATE,
  COMMENT,
  RENTABLE_UNIT_ID,
  NEIGHBOURHOOD,
  PROPERTY_TYPE,
  BUDGET,
  TENANT_PROFILE,
  DEVICE,
  BROWSER,
  PHONE_NUMBER_OPTIONAL,
  DOUBT_MOTIVE
} from './formFields';

const NON_BOOKING_FORM_FIELDS = [PHONE_NUMBER_OPTIONAL, COMMENT];

export const TENANT_REASONS = {
  [ZENDESK_SUPPORT.TENANT_REASONS.LISTING_DOUBTS]: {
    fields: [
      CITY,
      RENTABLE_UNIT_ID,
      DOUBT_MOTIVE,
      COMMENT,
      PHONE_NUMBER_OPTIONAL,
      MOVE_IN_DATE
    ],
    helpCenterArticles: [
      {
        title: 'contact-us.tenant.articles.admin.fee',
        id: 'externals.help-center.admin-fee'
      },
      {
        title: 'contact-us.tenant.articles.local-registration',
        id: 'externals.help-center.local-registration'
      },
      {
        title: 'contact-us.tenant.articles.security-deposit',
        id: 'externals.help-center.security-deposit'
      },
      {
        title: 'contact-us.tenant.articles.utility-bills',
        id: 'externals.help-center.utility-bills'
      }
    ]
  },
  [ZENDESK_SUPPORT.TENANT_REASONS.HELP_FIND_PROPERTY]: {
    fields: [
      CITY,
      COMMENT,
      NEIGHBOURHOOD,
      PROPERTY_TYPE,
      BUDGET,
      TENANT_PROFILE,
      PHONE_NUMBER_OPTIONAL,
      MOVE_IN_DATE
    ],
    helpCenterArticles: []
  },
  [ZENDESK_SUPPORT.TENANT_REASONS.TENANT_BUG]: {
    fields: [...NON_BOOKING_FORM_FIELDS, DEVICE, BROWSER],
    helpCenterArticles: []
  },
  [ZENDESK_SUPPORT.TENANT_REASONS.TENANT_OTHER]: {
    fields: NON_BOOKING_FORM_FIELDS,
    helpCenterArticles: [
      {
        title: 'contact-us.tenant.articles.tenants',
        id: 'externals.help-center.tenant-home'
      }
    ]
  },
  [ZENDESK_SUPPORT.TENANT_REASONS.HOW_SPOTAHOME_WORKS]: {
    fields: [],
    helpCenterArticles: [
      {
        title: 'contact-us.tenant.articles.contact-ll',
        id: 'externals.help-center.contact-landlord'
      },
      {
        title: 'contact-us.tenant.articles.how-it-works',
        id: 'externals.help-center.how-it-works'
      },
      {
        title: 'contact-us.tenant.articles.visit',
        id: 'externals.help-center.visit'
      },
      {
        title: 'contact-us.tenant.articles.fee',
        id: 'externals.help-center.fee'
      }
    ]
  },
  [ZENDESK_SUPPORT.TENANT_REASONS.DEACTIVATE_ACCOUNT]: {
    fields: [COMMENT],
    helpCenterArticles: [
      {
        title: 'contact-us.tenant.articles.persona-data',
        id: 'externals.help-center.personal-data'
      }
    ],
    postActions: ['disableUser', 'logoutUser']
  },
  [ZENDESK_SUPPORT.TENANT_REASONS.PAYMENT_SUPPORT]: {
    fields: [
      CITY,
      COMMENT,
      NEIGHBOURHOOD,
      PROPERTY_TYPE,
      BUDGET,
      TENANT_PROFILE,
      PHONE_NUMBER_OPTIONAL,
      MOVE_IN_DATE
    ],
    helpCenterArticles: []
  }
};
